module.exports = __webpack_public_path__ + "static/img/L-360-1.1d5b6e5a.png";